import React from 'react';
import './Error.css';
var ErrorMessage = function (_a) {
    var text = _a.text;
    return React.createElement("div", { className: "error" }, text);
};
export default ErrorMessage;
